import { useRef } from "react";
import { ConfirmDialog, type ConfirmDialogHandle } from "../components/ConfirmDialog";
import { ConfirmDialogContext } from "./confirmDialogContext";

export const ConfirmDialogProvider = ({ children }: React.PropsWithChildren) => {
  const ref = useRef<ConfirmDialogHandle>(null);

  return (
    <ConfirmDialogContext.Provider
      value={{ openDialog: (options) => ref.current?.openDialog(options) }}
    >
      {children}
      <ConfirmDialog ref={ref} />
    </ConfirmDialogContext.Provider>
  );
};
